import * as questionIds from "../../consultationQuestions/questionIds";

export const spirometryQuestions = [
    {
        id: questionIds.SpirometryUnableToCarryOut,
        questionText: "Unable to carry out medical",
    },
    {
        id: questionIds.SpirometryUnableToCarryOutReason,
        questionText: "Reason medical not carried out",
    },
    {
        id: questionIds.SpirometryMachineSerialNumber,
        questionText: "Serial number of machine",
    },
    {
        id: questionIds.SpirometryMachineCalibrationDate,
        questionText: "Calibration date (most recent)",
    },
    {
        id: questionIds.SpirometryReasonForAttending,
        questionText: "Reason for attending",
    },
    {
        id: questionIds.SpirometryLastTestDate,
        questionText: "Date of last test",
    },
    {
        id: questionIds.SpirometryGender,
        questionText: "Gender",
    },
    {
        id: questionIds.SpirometryAge,
        questionText: "Age",
    },
    {
        id: questionIds.SpirometryTestStartDate,
        questionText: "Start date (of current test)",
    },
    {
        id: questionIds.SpirometryCurrentOrHistoricalIssues,
        questionText: "Current or historical issues for client which may impact on test result or contraindication to testing client today",
    },
    {
        id: questionIds.Height,
        questionText: "Height (m)",
    },
    {
        id: questionIds.Height,
        questionText: "Weight (kg)",
    },
    {
        id: questionIds.SpirometryEthnicity,
        questionText: "Ethnicity",
    },
    {
        id: questionIds.SpirometrySmoker,
        questionText: "Smoker",
    },
    {
        id: questionIds.SpirometryVcLitres,
        questionText: "VC (litres)",
    },
    {
        id: questionIds.SpirometryFvcLitres,
        questionText: "FVC (litres)",
    },
    {
        id: questionIds.SpirometryFvcLitresPredicted,
        questionText: "FVC (litres) Predicted",
    },
    {
        id: questionIds.SpirometryFvcLitresPercentPredicted,
        questionText: "FVC (litres) % Predicted",
    },
    {
        id: questionIds.SpirometryFev1Litres,
        questionText: "FEV1 (litres)",
    },
    {
        id: questionIds.SpirometryFev1LitresPredicted,
        questionText: "FEV1 (litres) Previcted",
    },
    {
        id: questionIds.SpirometryFev1LitresPercentPredicted,
        questionText: "FEV1 (litres) % Predicted",
    },
    {
        id: questionIds.SpirometryFev1FvcRatio,
        questionText: "FEV1/FVC ratio %",
    },
    {
        id: questionIds.SpirometryFev1FvcRatioPredicted,
        questionText: "FEV1/FVC ratio % Predicted",
    },
    {
        id: questionIds.SpirometryFev1FvcRatioPercentPredicted,
        questionText: "FEV1/FVC ratio % % Predicted",
    },
    {
        id: questionIds.SpirometryFef2575,
        questionText: "FEF 25-75",
    },
    {
        id: questionIds.SpirometryPefrLitresPerMinute,
        questionText: "PEFR (l/min)",
    },
    {
        id: questionIds.SpirometryResultsExplained,
        questionText: "Results explained to employee with implications for future impact on respiratory health?",
    },
    {
        id: questionIds.SpirometryRequiresRegularFaceFitTesting,
        questionText: "Employee requires regular face fit testing for role",
    },
    {
        id: questionIds.SpirometryUnderstandsImportanceOfBeingCleanShaven,
        questionText: "Employee understands the importance of being clean shaven for effective mask fitting and prevention of work related lung disease",
    },
    {
        id: questionIds.SpirometryReferredDueToCleanShavenUnderstanding,
        questionText: "Referred to manager",
    },
    {
        id: questionIds.SpirometryPpeAvailableForInspection,
        questionText: "PPE available for inspection?",
    },
    {
        id: questionIds.SpirometryPpeComfortableAndFitForPurpose,
        questionText: "PPE comfortable and fit for purpose",
    },
    {
        id: questionIds.SpirometryPpeComfortableAndFitForPurposeComments,
        questionText: "Details",
    },
    {
        id: questionIds.SpirometryRespiratoryProtectionLeafletOrAdviceGiven,
        questionText: "Respiratory protection leaflet or verbal advice given to employee for ongoing respiratory protection",
    },
    {
        id: questionIds.SpirometryReferralRequired,
        questionText: "Does employee require referral?",
    },
    {
        id: questionIds.SpirometryAdviceRecommendationForGpSupplied,
        questionText: "Advice/recommendation letter for GP supplied to employee today?",
    },
    {
        id: questionIds.SpirometryReviewDateRecommended,
        questionText: "Review date recommended?",
    },
    {
        id: questionIds.SpirometryReviewDateOtherDetails,
        questionText: "",
    }
];
